import { render, staticRenderFns } from "./GenericWizard.vue?vue&type=template&id=015675d3&scoped=true"
import script from "./GenericWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericWizard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GenericWizard.vue?vue&type=style&index=0&id=015675d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015675d3",
  null
  
)

export default component.exports